import { useHistory } from 'react-router-dom'

export const useRedirect = (): ((to: string) => void) => {
  const history = useHistory()

  // eslint-disable-next-line fp/no-mutating-methods
  return (to: string) => history.push(to)
}
